import React, { Component, Fragment } from "reactn";
import { $ } from "js/vendor";
import { controls } from "js/editor/ui";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import UserOptionsContainer from "js/react/views/UserOptions/UserOptionsContainer";
import { UIController } from "js/editor/dialogs/UIController";
import { app } from "js/namespaces";
import Avatar from "js/react/components/Avatar";
import { Menu, MenuItem, Icon, Popover, Select } from "@material-ui/core";
import { NestedMenuItem } from "js/editor/elementUI/EditorComponents/NestedMenuItem";
import { ds } from "js/core/models/dataService";
import styled from "styled-components";
import { FeatureType } from "common/features";
import { getPricingPageUrl } from "js/core/utilities/pricing";
import { trackActivity, trackState } from "js/core/utilities/utilities";
import renderReactRoot from "js/react/renderReactRoot";
import { Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { themeColors } from "js/react/sharedStyles";

const MenuLabel = styled.div`
    font-size: 11px;
    text-transform: uppercase;
    color: #666;
    padding: 10px 0px 0px 14px;
    font-weight: 600;
`;

export class UserMenu extends Component {
    state = {
        anchorEl: null
    }

    showMenu = event => {
        this.setState({
            anchorEl: event.currentTarget
        });
    }

    closeMenu = event => {
        this.setState({
            anchorEl: null
        });
    }

    getWorkspaceName = workspace => {
        if (workspace.id == "personal") {
            return "Personal";
        } else {
            const defaultTeam = ds.teams.find(team => team.get("isDefault") && team.get("orgId") === workspace.id);
            return defaultTeam.get("name");
        }
    }

    handleEditProfile = () => {
        this.closeMenu();
        UIController.showUserOptionsDialog("account");
    }

    handleManageTeam = () => {
        this.closeMenu();
        UIController.showUserOptionsDialog("manage-default-team");
    }

    trackWorkspaceState(workspaceId) {
        const workspace = app.user.workspaces[workspaceId];
        trackState({
            ...workspace.getAnalytics(),
            "presentation_id": null,
        });
    }

    handleSwitchWorkspace = workspaceId => {
        this.closeMenu();

        this.trackWorkspaceState(workspaceId);
        app.appState.changePresentationsWorkspace(workspaceId);
        app.appState.clearLibraryLocation();

        if (app.mainView.editorView) {
            app.router.navigate("/", { trigger: true });
        } else {
            app.mainView.render();
        }
    }

    handleCreateWorkspace = () => {
        const userIsBasicInWorkspace = app.user.features.isFeatureEnabled(FeatureType.UPGRADE, UIController.getWorkspaceId());
        const currentPlan = userIsBasicInWorkspace ? "basic" : "pro";
        window.open(getPricingPageUrl(app && app.user.hasTakenTrial, app && app.user.has("hasTakenTeamTrial"), currentPlan), "_blank");
    }

    handleLogout = () => {
        trackActivity("Auth", "logout", null, null, { workspace_id: "all" }, { audit: true });
        ds.shutdown();
        window.location = "/logout";
    }

    render() {
        let { canSwitchWorkspace } = this.props;
        let { anchorEl } = this.state;

        let workspace = app.user.workspaces[UIController.getWorkspaceId()];

        return (
            <Fragment>
                <Avatar id="userMenu" onClick={this.showMenu} url={this.global.accountAvatarUrl} />
                <Menu
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.closeMenu}
                >
                    <MenuItem id="menu-item-profile" onClick={this.handleEditProfile}><Icon>account_circle</Icon>Manage Account</MenuItem>
                    <hr/>
                    <NestedMenuItem
                        id="menu-item-workspace"
                        showNestedOnClick
                        disabled={!canSwitchWorkspace}
                        contents={
                            <Fragment><Icon>{workspace.icon}</Icon>Switch Workspace</Fragment>
                        }>
                        {
                            Object.values(app.user.workspaces).map(ws => {
                                return (
                                    <MenuItem
                                        key={ws.id}
                                        value={ws.id}
                                        onClick={() => this.handleSwitchWorkspace(ws.id)}
                                    >
                                        {ws == workspace && <Icon style={{ color: themeColors.ui_blue }}>check</Icon>}
                                        {ws != workspace && <Gap30/>}
                                        <Icon>{ws.icon}</Icon>
                                        {this.getWorkspaceName(ws)}
                                        <Gap10/>
                                    </MenuItem>
                                );
                            })
                        }
                        {
                            !app.integrator &&
                            <>
                                <hr/>
                                <MenuItem key="create" onClick={this.handleCreateWorkspace}>Create Workspace...</MenuItem>
                            </>
                        }
                    </NestedMenuItem>
                    <hr/>
                    <MenuItem id="menu-item-logout" onClick={this.handleLogout}><Icon>logout</Icon>Log out</MenuItem>
                </Menu>
            </Fragment>
        );
    }
}

export function renderUserMenu($el, canSwitchWorkspace) {
    let $div = $el.addEl($.div());
    renderReactRoot(UserMenu, { canSwitchWorkspace }, $div[0]);
}

// function updateAvatar($el) {
//     const avatarUrl = app.user.getAvatarUrl();
//     this.$avatar = $el.find(".avatar");
//     if (avatarUrl) {
//         $el.find(".avatar").html($.img(avatarUrl).addClass("micon"));
//     } else {
//         $el.find(".avatar").html($.icon("person").addClass("micon"));
//     }
// }
